import { render, staticRenderFns } from "./DidYouKnow.vue?vue&type=template&id=6c11fb92"
import script from "./DidYouKnow.vue?vue&type=script&lang=js"
export * from "./DidYouKnow.vue?vue&type=script&lang=js"
import style0 from "./DidYouKnow.vue?vue&type=style&index=0&id=6c11fb92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports